export const types = ['Month', 'Week', 'Day', 'Year'];
export const minControlWidth = 100;
export const timeWidth = 50;
export const timeWidthHalf = 60;
export const dayTimeByPart = 2;
export const weekObj = [_l('周一'), _l('周二'), _l('周三'), _l('周四'), _l('周五'), _l('周六'), _l('周日')];
export const GroupControlWidth = 100;
export const minHeightObj = [32, 44, 56];
export const BlockHeight = minHeightObj[0];
export const lineHeight = 22;
export const lineBottomHeight = 20;
export const resourceTypes = [
  { text: _l('年'), value: '3', key: 'Year' },
  { text: _l('月'), value: '0', key: 'Month' },
  { text: _l('周'), value: '1', key: 'Week' },
  { text: _l('日'), value: '2', key: 'Day' },
];

export const kanbanSize = 50;
export const pageSize = 50;
